import { Button, styled } from '@mui/material';
import { SnackbarContent } from 'notistack';

import { styledCustom } from '/styles';

export const KBAR_BACKGROUND_COLOR = '#616161';

export const StyledSnackBarContent = styledCustom(SnackbarContent)<{ $backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px 6px 20px;
  font-size: 0.875rem;
  min-width: 288px;
  border-radius: 4px;
  background-color: ${({ $backgroundColor }) => $backgroundColor ?? 'inherit'};
  transition: background-color 0.5s ease;

  ${({ theme }) => `
    color: ${theme.palette.common.white};
  `}
`;

export const StyledSnackBarButton = styled(Button)`
  transition: color 0.5s ease;
  padding: 6px 8px;
`;
